import React from 'react'
import AdminAdverts from '../../Components/AdminAdverts'

const AdminAdvertTasks = () => {
  return (

<div className="bg-black">
      <AdminAdverts/>
 </div>
  )
}

export default AdminAdvertTasks